/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Lines_Scroll_HintInputs */

const vi_einvoice_draft_lines_scroll_hint = /** @type {(inputs: Einvoice_Draft_Lines_Scroll_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kéo ngang bảng để xem chiết khấu, VAT và nút xóa dòng.`)
};

/**

* @param {Einvoice_Draft_Lines_Scroll_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_lines_scroll_hint = /** @type {((inputs?: Einvoice_Draft_Lines_Scroll_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Lines_Scroll_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_lines_scroll_hint(inputs)
});